import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@environments/environment";
import { Observable, ReplaySubject } from "rxjs";

import { Perfil } from "../Entities/Perfil/perfil.entity";

const { enlineaBackendUrl } = environment;

@Injectable({
  providedIn: "root",
})
export class PerfilRepository {
  private perfiles: ReplaySubject<Perfil[]>;
  private readonly perfilesFiduciaria: ReplaySubject<Perfil[]>;

  constructor(private http: HttpClient) {}

  //GET
  getPerfiles(overwrite = false): Observable<Perfil[]> {
    if (!this.perfiles || overwrite) {
      if (!this.perfiles) this.perfiles = new ReplaySubject(1);

      this.http.get<Perfil[]>(`${enlineaBackendUrl}/api/Perfiles?spinner=true`).subscribe((results) => {
        this.perfiles.next(results);
      });
    }

    return this.perfiles;
  }

  public getPerfilesFiduciaria(overwrite = false): Observable<Perfil[]> {
    return  this.http.get<Perfil[]>(`${enlineaBackendUrl}/api/FiduciariaPerfiles/ObtenerPerfiles?spinner=true`);
  }

  getPerfil(id): Observable<Perfil> {
    return this.http.get<Perfil>(`${enlineaBackendUrl}/api/Perfiles/ObtenerPerfil/${id}`);
  }

  //POST
  savePerfil(perfil: Perfil): Observable<Perfil> {
    return this.http.post<Perfil>(`${enlineaBackendUrl}/api/Perfiles`, perfil);
  }

  //PATCH
  updatePerfil(perfil: Perfil): Observable<any> {
    return this.http.patch(`${enlineaBackendUrl}/api/Perfiles`, perfil);
  }

  //DELETE
  deletePerfil(perfil: Perfil): Observable<any> {
    return this.http.delete(`${enlineaBackendUrl}/api/Perfiles/${perfil.id}`);
  }
}
